const focusItems = [
  {
    title: '暑期档观影指南',
    tag: '专题策划',
    desc: '这个夏天不可错过的十部好片，从科幻巨制到温情喜剧，一站式推荐。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20marathon%20concept%20with%20warm%20sunlight%20and%20film%20reels%2C%20vibrant%20poster%20collage%20style%2C%20golden%20hour%20lighting&width=700&height=420&seq=focus-card-01&orientation=landscape',
  },
  {
    title: '国产科幻崛起之路',
    tag: '深度专题',
    desc: '从特效技术到叙事突破，国产科幻电影如何一步步征服观众。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20film%20theme%20with%20futuristic%20elements%20and%20traditional%20Chinese%20aesthetics%2C%20dramatic%20cosmic%20background%2C%20artistic%20composition&width=700&height=420&seq=focus-card-02&orientation=landscape',
  },
  {
    title: '悬疑片入门必看',
    tag: '编辑精选',
    desc: '从入门到进阶的悬疑片单，每一部都让你猜不到结局。',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20film%20collection%20theme%20with%20magnifying%20glass%20and%20film%20noir%20elements%2C%20dark%20moody%20atmosphere%2C%20cinematic%20lighting&width=700&height=420&seq=focus-card-03&orientation=landscape',
  },
  {
    title: '经典港片回顾',
    tag: '怀旧专题',
    desc: '那些年我们一起追过的港产片，重温黄金年代的银幕记忆。',
    img: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20theme%20with%20neon%20signs%20and%20film%20elements%2C%20nostalgic%20vintage%20aesthetic%2C%20warm%20golden%20tones&width=700&height=420&seq=focus-card-04&orientation=landscape',
  },
  {
    title: '动画电影年度盘点',
    tag: '年度特辑',
    desc: '这一年值得一看的动画电影都在这里了，治愈与热血并存。',
    img: 'https://readdy.ai/api/search-image?query=Animation%20film%20showcase%20theme%20with%20colorful%20illustration%20style%2C%20magical%20atmosphere%2C%20vibrant%20warm%20colors%2C%20cinematic%20quality&width=700&height=420&seq=focus-card-05&orientation=landscape',
  },
  {
    title: '高分韩剧特辑',
    tag: '海外精选',
    desc: '口碑炸裂的韩剧推荐，从甜宠到暗黑，总有一款适合你。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20collection%20theme%20with%20elegant%20cinematic%20composition%2C%20warm%20romantic%20atmosphere%2C%20soft%20lighting%20and%20modern%20aesthetic&width=700&height=420&seq=focus-card-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            焦点专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">深度策划，发现更多精彩影视内容</p>
        </div>

        {/* All items visible at once — horizontal scroll on small screens, grid on desktop */}
        <div className="flex lg:grid lg:grid-cols-3 gap-5 overflow-x-auto lg:overflow-visible pb-4 lg:pb-0 -mx-4 lg:mx-0 px-4 lg:px-0 snap-x snap-mandatory scrollbar-hide">
          {focusItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex-shrink-0 w-[85vw] sm:w-[340px] lg:w-auto snap-start rounded-xl bg-background-50 border border-background-200/60 overflow-hidden hover:border-accent-200 transition-all cursor-pointer no-underline"
            >
              <div className="aspect-[5/3] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors" style={{ fontFamily: 'var(--font-heading)' }}>
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}